import { Module } from 'vuex';
import { getters } from './getters';
import { createActions } from './actions';
import { mutations } from './mutations';
import { UserState } from './types';
import { RootState } from '../types';
import Bff from '@/api/bff';

export const state: UserState = {
  currentUser: null,
  isLoggedIn: false,
  isEmailVerified: false,
  error: false,
  firebaseUser: null,
  users: []
};

export function create(bff: Bff): Module<UserState, RootState> {
  const actions = createActions(bff);
  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}

export const name = 'userModule';
